
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Go to Welcome page',


	'widgetsListLabel': 'Widgets list. Select a widget and press enter to add.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Up-to-date',
	'dirty': 'Not up-to-date',
	'conflict': 'Conflict saving the view',
	'error': 'Problem saving the view',
	'failure': 'Unable to contact the server',
	'saveFailed': 'Unable to save the view',

	'wa_insync': 'Saved',
	'wa_conflict': 'Conflict saving the view',
	'wa_error': 'Unable to save the view',
	'wa_failure': 'Unable to contact the server',

	// Menu Labels
	'changeDisplay': 'Change display',
	'changeToColumnChart': 'Change to column chart',
	'changeToBubbleChart': 'Change to bubble chart',
	'toggleMoveHandles': 'Toggle move handles',
	'undo': 'Undo',
	'redo': 'Redo',
	'mode': 'Change the mode',

	'untitled': 'Untitled',
	'remove': 'Remove',
	'editTitle': 'Edit the title',
	'edit': 'Edit',
	'done': 'Done',

	// Data tray
	'dataTrayHandleOpenLabel': 'Open data tray',
	'dataTrayHandleCloseLabel': 'Close data tray',

	// Dialogs
	'dlg_loading': 'Loading...',
	'dlg_ok': 'OK',
	'dlg_create': 'Create',
	'dlg_cancel': 'Cancel',
	'dlg_close': 'Close',
	'dlg_update': 'Update',
	'dlg_renameBoardTitle': 'Rename this object',
	'dlg_renameDatasetTitle': 'Rename this data set',
	'dlg_renameSceneTitle': 'Rename this scene',
	'dlg_NameLabel': 'Name:',
	'dlg_NewNameLabel': 'New name:',
	'dlg_DefaultNameWithDataSet': '%{name} View',
	'dlg_ShareTitle': 'Share content',
	'dlg_UnshareTitle': 'Remove content sharing',
	'dlg_ShareUser': 'User ID:',
	'dlg_NewColumnLabel': 'New calculation name',

	'dlg_new': 'New...',
	'dlg_open': 'Open...',
	'dlg_makeACopy': 'Make a copy',
	'dlg_rename': 'Rename...',
	'dlg_moreToCome': 'More actions coming...',

	'dlg_use': 'Use',

	'dlg_RelinkDatasetTitle': 'Replace data set \'%{datasetName}\' with ...',

	'open_error': 'A problem occurred while opening the view.',

	// Delete Board
	'del_dialogTitle': 'Confirm deletion',
	'del_itemMsg': 'Are you sure you want to delete \'%{name}\'?',
	'del_itemsMsg': 'Are you sure you want to delete %{count} items?',
	'del_deleteErr': 'Unable to delete \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'ascending',
	'dlg_descending': 'descending',
	'dlg_custom': 'custom',
	'dlg_none': 'none',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Search',

	'searchHint': 'Search all your data',
	'clearSearchResult': 'Clear search results',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Circle',
	'shapesHexagon': 'Hexagon',
	'shapesLine': 'Line',
	'shapesOctagon': 'Octagon',
	'shapesPentagon': 'Pentagon',
	'shapesSquare': 'Square',
	'shapesTriangle': 'Triangle',
	'shapesDiamond': 'Diamond',
	'shapesTitle': 'Shape properties', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Rounded square',
	'shapesStar': 'Star',
	'shapesChevron': 'Chevron',
	'shapesBadge_ribbon': 'Badge ribbon',
	'shapesBadge': 'Badge',
	'shapesHeart': 'Heart',
	'shapesExclamation': 'Exclamation',
	'shapesTrendingup': 'Trending up',
	'shapesTrendingdown': 'Trending down',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'People',
	'shapesFemale': 'Female',
	'shapesHappyface': 'Happy face',
	'shapesMale': 'Male',
	'shapesMan': 'Man',
	'shapesNeutralface': 'Neutral face',
	'shapesSadface': 'Sad face',
	'shapesShakehands': 'Shake hands',
	'shapesThumbsdown': 'Thumbs down',
	'shapesThumbsup': 'Thumbs up',
	'shapesWoman': 'Woman',

	// Weather and places
	'shapesPlacesWeatherCat': 'Places & weather',
	'shapesCity': 'City',
	'shapesCloud': 'Cloud',
	'shapesEducation': 'Education',
	'shapesGovernment': 'Government',
	'shapesHalfcloud': 'Half cloud',
	'shapesHouse': 'House',
	'shapesMoon': 'Moon',
	'shapesRain': 'Rain',
	'shapesSunny': 'Sunny',

	//Vehicles
	'shapesVehiclesCat': 'Vehicles',
	'shapesAirplane': 'Airplane',
	'shapesCar': 'Car',
	'shapesShip': 'Ship',
	'shapesShoppingcart': 'Shopping cart',
	'shapesTrain': 'Train',
	'shapesTruck': 'Truck',

	//Objects
	'shapesObjectsCat': 'Objects',
	'shapesBook': 'Book',
	'shapesBriefcase': 'Briefcase',
	'shapesCalendar': 'Calendar',
	'shapesCheck': 'Check',
	'shapesClock': 'Clock',
	'shapesDesktop': 'Desktop',
	'shapesDocument': 'Document',

	'shapesFood': 'Food',
	'shapesGear': 'Gear',
	'shapesHealth': 'Health',

	'shapesIdea': 'Idea',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Money bill',
	'shapesMoney_coin': 'Money coin',
	'shapesPiggybank': 'Piggy bank',
	'shapesStackofpaper': 'Stack of paper',
	'shapesStickynote1': 'Sticky note 1',
	'shapesStickynote2': 'Sticky note 2',
	'shapesTarget': 'Target',
	'shapesTool': 'Tool',

	'shapesUmbrella': 'Umbrella',

	'shapesBrain': 'Brain',
	'shapesSkull': 'Skull',
	'shapesEye': 'Eye',

	// Arrows shapes
	'shapesArrowsCat': 'Arrows',
	'shapesRightArrow': 'Right arrow',
	'shapesLeftArrow': 'Left arrow',
	'shapesDoubleArrow': 'Double arrow',
	'shapesCurvedArrow': 'Curved arrow',

	// Callouts shapes
	'shapesCalloutsCat': 'Callouts',
	'shapesRectCallout': 'Callout',

	// Images
	'imagesCat': 'Images',
	'imageWidgetTitle': 'Image widget',
	'imgUrl': 'Image URL',
	'noImgSelected': 'No image selected',
	'enterImgUrl': 'Enter image URL here',
	'imgPasteLink': 'Paste the URL and press Enter to save it.',
	'imgResizeToFit': 'Resize to fit the image\'s size',
	'imgHeight': 'Height:',
	'imgWidth': 'Width:',
	'imgTransparency': 'Transparency:',
	'imgMissingUrl': 'The image URL is missing.',
	'imgUrlValidationError': 'The image URL is not valid.',
	'imgUrlInvalidDomainError': 'The image URL is pointing to a domain that has not been approved by your administrator. The domains approved by your administrator are "%{domains}".',

	// line shape
	'propStrokeWidth': 'Line thickness',
	'propStrokeDashArray': 'Line style',
	'propStrokeSolidline': 'Solid line',
	'propStrokeLineCap': 'Line cap',
	'propStrokeLineCapButt': 'Butt',
	'propStrokeLineCapRound': 'Round',
	'propStrokeLineCapSquare': 'Square',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Play',
	'dataPlayerValueListLabel': 'Data player values',
	// Text Widget
	'textWidgetTitle': 'Text widget',
	'textStyle': 'Styles',
	'textStyleDescription': 'Preformatted text styles',
	'textTitleStyle': 'Title',
	'textTitleSmallStyle': 'Title small',
	'textSubtitleStyle': 'Subtitle',
	'textBodyStyle': 'Body',
	'textBodySmallStyle': 'Body small',
	'textCaptionStyle': 'Caption',
	'textQuoteStyle': 'Quote',
	'textQuoteSmallStyle': 'Quote small',
	'textResponsiveStyle': 'Auto-size',
	'textAutoFontSize': 'Auto',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hairline',
	'textFontFamilySubClassThin': 'Thin',
	'textFontFamilySubClassThinItalic': 'Thin Italic',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Extra Light Italic',
	'textFontFamilySubClassLight': 'Light',
	'textFontFamilySubClassLightItalic': 'Light Italic',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Regular Italic',
	'textFontFamilySubClassItalic': 'Italic',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium Italic',
	'textFontFamilySubClassHeavy': 'Heavy',
	'textFontFamilySubClassHeavyItalic': 'Heavy Italic',
	'textFontFamilySubClassDemiBold': 'Demi Bold',
	'textFontFamilySubClassDemiBoldItalic': 'Demi Bold Italic',
	'textFontFamilySubClassBold': 'Bold',
	'textFontFamilySubClassBoldItalic': 'Bold Italic',
	'textFontFamilySubClassExtraBold': 'Extra Bold',
	'textFontFamilySubClassExtraBoldItalic': 'Extra Bold Italic',
	'textFontFamilySubClassBlack': 'Black',
	'textFontFamilySubClassBlackItalic': 'Black Italic',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Auto-size font',
	'responsiveCoachmarkContents': 'The font size automatically resizes to fit when you resize this text type. You can set the font size in the text properties.',

	'propText': 'Text details', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Text properties', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Font size',
	'textFontFamily': 'Font family',
	'textFontWeight': 'Font weight', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Image link',
	'propMissingURL': 'Enter URL',
	'propImgTop': 'Image properties', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'General properties', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Fill color', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Text color', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Border color',
	'propMaintainAxisScales': 'Maintain axis scale',
	'propShowItemLabel': 'Show the item label',
	'propHideLegend': 'Hide the legend',
	'propColorPalette': 'Palette',
	'propLegendPosition': 'Legend position',
	'propHideAxisTitleLabels': 'Hide axis titles',
	'propLineColor': 'Line color',
	'propBubbleColor': 'Bubble color',
	'propInterpolation': 'Smooth lines',
	'propElementColor': 'Visualization element color',
	'propSymbolShape': 'Symbol shape',
	'propHeatScalePalette': 'Color order',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Darker colors represent smaller values.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Darker colors represent larger values.',
	'propImageDetails': 'Image details', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Web page details', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Media details', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Enter the URL and press Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Position & style',
	'propPositionLabel': 'Position', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Size', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Width',
	'propResizeHeight': 'Height',
	'propRotateLabel': 'Rotate',
	'propRotateAngle': 'Angle', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Quantity of icons',
	'propScaleDescription': 'Select the quantity of icons',
	'propScaleFew': 'Low',
	'propScaleDefault': 'Default',
	'propScaleMany': 'High',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'This value must be numeric',

	'mediaAriaLabel': 'url input',
	'dropdownAriaLabel' : 'Dropdown',
	'ariaGroupLabel': 'Dropdown list category: %{cateoryLabel} item: %{itemLabel}. Press DOWN key to expand. Press UP and DOWN key to navigate or Press ESCAPE key to collapse.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Last refresh: %{timeInterval} ago',
	'widgetTimer': 'Widget timer',

	// Theme colors
	'transparent': 'No color',
	'white': 'White',
	'lightGrey': 'Light grey',
	'grey': 'Grey',
	'darkGrey': 'Dark grey',
	'black': 'Black',
	'lightBlue': 'Light blue',
	'blue': 'Blue',
	'darkBlue': 'Dark blue',
	'yellow': 'Yellow',
	'orange': 'Orange',
	'lime': 'Lime',
	'green': 'Green',
	'peach': 'Peach',
	'red': 'Red',
	'violet': 'Violet',
	'aqua': 'Aqua',
	'purple': 'Purple',
	'plum': 'plum',
	'gray10': 'Grey 10',
	'gray20': 'Grey 20',
	'gray30': 'Grey 30',
	'gray50': 'Grey 50',
	'gray60': 'Grey 60',
	'gray70': 'Grey 70',
	'gray80': 'Grey 80',
	'gray90': 'Grey 90',
	'gray100': 'Grey 100',
	'blue50': 'Blue 50',
	'blue60': 'Blue 60',
	'blue70': 'Blue 70',
	'green40': 'Green 40',
	'green50': 'Green 50',
	'red50': 'Red 50',
	'red60': 'Red 60',


	//Theme Palette Label
	'paletteLabel': 'IBM palette %{number}',
	'heatPaletteLabel': 'IBM heat palette %{number}',
	'conditionalPaletteLabel': 'IBM conditional palette %{number}',
	'carbonPaletteXLight': 'Carbon X Light',
	'carbonPaletteXDark': 'Carbon X Dark',
	'carbonPalettePurple': 'Purple',
	'carbonPaletteTeal': 'Teal',
	'carbonPaletteCyan': 'Cyan',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Purple Teal',
	'carbonPaletteCyanMagenta': 'Cyan Magenta',
	'carbonPaletteGreenRed': 'Green Red',
	'carbonPaletteGreenYellowRed': 'Green Yellow Red',
	'carbonPalettePurpleTealConvergent': 'Purple Teal Convergent',
	'carbonPaletteCyanMagentaConvergent': 'Cyan Magenta Convergent',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM light palette',
	'userPaletteColor_defaultTheme': 'IBM default palette',
	'userPaletteColor_darkTheme': 'IBM dark palette',

	// Dashboard
	'propDashboardBackgroundColor': 'Background color',
	'propLayoutPositioning': 'Layout positioning',
	'propLayoutRelative': 'Relative',
	'propLayoutAbsolute': 'Absolute',
	'propLayoutPositioningCoachmarkTitle': 'Select a layout style',
	'propLayoutPositioningCoachmarkContent': 'In a relative layout, the size and position of widgets adjust to fit into the screen. Widgets in an absolute layout appear exactly as you size and place them in the view, regardless of the screen size.',
	'gridText': 'Show grid',
	'snapText': 'Snap to grid',
	'snapObjectsText': 'Snap to objects',
	'fitPageText': 'Fit page',
	'gridLabel': 'Grid',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Page size',
	'propPageSizePresetAriaLabel': 'Page size preset',
	'propPageSizePreset': 'Preset',
	'propPageSizePresetCustom': 'Custom',
	'propPageSizePreset16x9': 'Screen 16:9',
	'propPageSizePreset4x3': 'Screen 4:3',
	'propPageSizePresetInfographic': 'Infographic',
	'propPageSizeWidth': 'Width',
	'propPageSizeHeight': 'Height',
	'propPageSizeWidthAriaLabel': 'Page size width',
	'propPageSizeHeightAriaLabel': 'Page size height',
	'propPageSizeAdjustedMessage': 'The page size was increased because your entry was below the minimum or would not fit your dashboard.',
	'propTabShow': 'Show tabs',
	'propShowTabsInPreview': 'Show tabs in preview',
	'multilingualDashboardsLabel': 'Languages',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Default',
	'multilingualDashboardsAddLinkText': 'Add another language',
	'multilingualDashboardsSelect': 'Select',
	'multilingualDashboardsButtonLabel': 'Add',
	'multilingualDashboardTranslationMode': 'You are now in translation mode (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Done',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} translations remaining',
	'multilingualDashboardRemainingString': '1 translation remaining',
	'multilingualDashboardsSetDefault': 'Set default language',
	'multilingualDashboardIconMore': 'More actions for language %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Translatable area',
	'multilingualDeleteTitle': 'Delete language',
	'multilingualDeleteLanguageWarning': 'Are you sure you want to delete the language \'%{language}\'?',
	'multilingualSelectLanguage': 'Select a language',
	'confirmLayoutStyleUpgradeTitle': 'Apply to all tabs',
	'confirmLayoutStyleUpgrade': 'Apply this layout style to all tabs in your dashboard?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Delete',
	'tabDeleteDialogTitle': 'Delete this tab?',
	'tabDeleteDialogMessage': 'All content on this tab will also be deleted.',

	// Vis widget
	'propVisTypeReturn': 'Visualization types',
	'propVisDetails': 'Details',

	// Alignment picker
	'propAlignPickTop': 'Align top',
	'propAlignPickRight': 'Align right',
	'propAlignPickBottom': 'Align bottom',
	'propAlignPickLeft': 'Align left',
	'propAlignPickCenter': 'Align center',
	'propAlignPicker': 'Alignment',

	// Toolbar picker
	'propToolbarPickBold': 'Bold',
	'propToolbarPickUnderline': 'Underline',
	'propToolbarPickItalic': 'Italic',
	'propToolbarPickJustifyLeft': 'Align left',
	'propToolbarPickJustifyCenter': 'Align center',
	'propToolbarPickJustifyRight': 'Align right',
	'propToolbarPickJustify': 'Justify',

	'propList': 'List',
	'propOrderedList': 'Ordered list',
	'propUnorderedList': 'Unordered list',

	// Symbol shapes
	'propCircle': 'Circle',
	'propTriangle': 'Triangle',
	'propSquare': 'Square',
	'propRect': 'Rectangle',
	'propStar': 'Star',
	'propCross': 'Cross',
	'propPlus': 'Plus',
	'propPoly': 'Polygon',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Left',
	'propRight': 'Right',
	'propTop': 'Top',
	'propBottom': 'Bottom',

	// Interpolation options
	'propSmooth': 'Smooth',
	'propStraight': 'Straight',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'List', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Move left', // screen reader
	'srWidgetMoveUp': 'Move up', // screen reader
	'srWidgetMoveRight': 'Move right', // screen reader
	'srWidgetMoveDown': 'Move down', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Increase the size proportionally', // screen reader
	'srWidgetResizeSmaller': 'Decrease the size proportionally', // screen reader
	'srWidgetResizeBiggerV': 'Increase the size vertically', // screen reader
	'srWidgetResizeSmallerV': 'Decrease the size vertically', // screen reader
	'srWidgetResizeBiggerH': 'Increase the size horizontally', // screen reader
	'srWidgetResizeSmallerH': 'Decrease the size horizontally', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rotate clockwise', // screen reader
	'srWidgetRotateCCW': 'Rotate counterclockwise', // screen reader

	// Recommended types
	'visChange': 'Change visualization',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualization',
	'chartLabel': '%{chartName} chart',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Press F12 to navigate within the widget',
	'f10KeyDescription': 'Press F10 to launch the widget focus view',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} with value %{value}',

	'shapeColorLabel': 'Shape color',
	'showLegendLabel': 'Show legend',

	//Webpage
	'webpageWidgetTitle': 'Webpage widget',
	'webpagePasteLink': 'Paste the URL and press Enter to save it.',
	'propWebpageLink': 'Web page URL',
	'propWebpageTitle': 'Web page title',
	'propWebpageTitleDescription': 'Title of the web page',
	'webpageUrl': 'Webpage URL',
	'noWebpageSelected': 'No webpage selected',
	'enterWebpageUrl': 'Enter webpage URL here',
	'propWebpageTop': 'Web page properties', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'The web page URL is missing.',
	'webpageUrlValidationError': 'The web page URL is not valid.',
	'webpageHttpValidationError': 'The web page must be accessed using an HTTPS link.',
	'webpageInvalidDomainError': 'The web page URL is pointing to a domain that has not been approved by your administrator. The domains approved by your administrator are "%{domains}".',

	//VizState
	'vzErrorLoading': 'Unable to load visualization',
	'vzErrorLoadingMissingData': 'Unable to load visualization, missing context data',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Media widget',
	'mediaPasteLink': 'Paste the URL and press Enter to save it.',
	'mediaUrl': 'Media URL',
	'noMediaSelected': 'No media selected',
	'enterMediaUrl': 'Enter media URL here',
	'videoHeight': 'Height:',
	'videoWidth': 'Width:',
	'propMediaLink': 'Media link',
	'propMediaTitle': 'Media title',
	'propMediaTitleDescription': 'Title of the media',
	'propMediaTop': 'Media properties', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'The media link URL is missing.',
	'mediaUrlValidationError': 'The media file URL is not valid.',
	'mediaUnknownValidationError': 'This type of media is not supported.',
	'mediaHttpValidationError': 'The media file must be accessed using an HTTPS link.',
	'mediaInvalidDomainError': 'The media file URL is pointing to a domain that has not been approved by your administrator. The domains approved by your administrator are "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Properties', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Data set',
	'dataViewsLabel': 'View',
	'columnQuality': 'Data quality',
	'columnProperties': 'Data properties',

	'dataQuality': 'Data quality',
	'dataQualityRowCount': 'Number of rows',
	'dataQualityDistribution': 'Distribution',
	'dataRowLabel': 'Data',

	// Modelling UI
	'typeColumn': 'Type',
	'modellingColumnType': 'Type',
	'modellingColumnAggregation': 'Aggregation',
	'modellingColumnUsage': 'Usage',
	'modellingColumnSort': 'Sort',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Category',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Loading...',

	'modellingProcessing': 'Processing...',
	'modellingImport': 'Import',
	'modellingReimport': 'Re-import',
	'modellingDatasourceTitle': 'Data source',
	'modellingImportStartedTitle': 'Importing started',
	'modellingImportStartedText': 'Importing your data may take a bit of time.\n\n(You can create a view while the data is imported.)',
	'importDatasourceTitle': 'Connections',
	'dropHere': 'Drop here to create a new data source...',
	'browseButton': 'Browse',
	'errorNoData': 'There is no data to process.',
	'errorNoFile': 'There is no file to upload.',
	'errorUploadFailed': 'Unable to upload.',
	'uploadSucceessful': 'Upload succeessful',
	'del_datasourceTitle': 'Delete data set',
	'del_datasourceMsg': 'Are you sure you wish to delete \'%{name}\'?',
	'modellingFileUpdate': 'Update',
	'modellingFileUpdateTitle': 'Update data set',
	'modellingFileUpdateDescription': 'Do you want to update \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Updating \'%{name}\'',
	'modellingUpdateStartedTitle': 'Update import started',
	'modellingUpdateStartedText': 'Updating your data may take a bit of time.\n\n(You can create a view while the data is updated.)',
	'modellingErrorImportUploadNoFile': 'No file to upload.',
	'modellingErrorImportUploadFailed': 'Unable to upload.',
	'modellingErrorImportUploadInvalidType': 'The file type is not valid.',
	'modellingErrorImportUploadTableFailed': 'Unable to get tables.',
	'modellingIntentResultsTitle': 'Select the proposed data set to use',
	'modellingColumnViewRelationships': 'View related tables',
	'modellingTableRelatedTables': 'Tables related to \'%{name}\'',
	'modellingTable': '%{name} - Table',
	'modellingColumnIncludedInDataSet': 'Added',
	'modellingDataSet': 'Data set',
	'modellingViewInDataSet': 'View in data set',
	'modellingViewRelatedTables': 'View related',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'No related tables found',

	'modellingValidatingDataset': 'Validating...',
	'datasetFinishedRefreshing': 'Data set %{datasetName} has been refreshed.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Resolve join path:',
	'modellingJoinColumns': 'Define a join path for table: %{name}',
	'modellingJoinToTable': 'Join to table: %{name}',

	// Data Quality
	'excluded': 'Excluded',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filter',
	'modellingColumnSortNone': 'Clear the sort',
	'modellingColumnSortAsc': 'Sort ascending',
	'modellingColumnSortDesc': 'Sort descending',
	'modellingColumnRemove': 'Remove this column',

	// Import File Browser
	'dropboxPageTitle': 'New Dropbox connection',
	'sizeColumn': 'Size',

	//Modelling Column Property Values
	'dataType_string': 'String',
	'dataType_date': 'Date',
	'dataType_integer': 'Integer',
	'dataType_double': 'Double',
	'dataType_float': 'Float',
	'dataType_boolean': 'Boolean',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Count',
	'defaultAggregation_countdistinct': 'Count distinct',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Average',
	'defaultAggregation_sum': 'Sum',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Fact',
	'type_attribute': 'Attribute',

	'defaultSort_none': 'Do not sort',
	'defaultSort_asc': 'Sort ascending',
	'defaultSort_desc': 'Sort descending',

	'category_none': 'None',
	'category_location': 'Location',
	'category_monetary': 'Monetary',
	'category_time': 'Time',

	// Root menu
	'rootMenuTitle': 'Main menu',

	'errorMessageTitle': 'Error',
	'errorMessageDetails': 'Details: ',
	'errorMessageTitleAssetAlreadyExists': 'Asset already exists',

	'defaultTabTitle': 'Tab %{index}',
	'tabAddBtnTitle': 'Add a new tab',

	'unsupportedConditionalFormattingEncountered': 'Conditional formatting is no longer applied to some columns.',


	// Homepage View
	'nameColumn': 'Name',
	'creatorColumn': 'Created by',
	'creationDateColumn': 'Date created',
	'versionColumn': 'Version',
	'modifiedColumn': 'Last Modified',

	'filterBy': 'Filter items',
	'allFilter': 'All items',
	'createdByMeFilter': 'Created by me',
	'sharedWithMeFilter': 'Shared with me',
	'favoritesFilter': 'My favorites',
	'recentsFilter': 'Recently added',
	'sortBy': 'Sort by',

	// Sort Menu
	'sortModified': 'Modified',
	'sortUpdated': 'Updated',
	'sortName': 'Name',

	'viewAs': 'View as',
	'thumbnailsView': 'View as thumbnails',
	'listView': 'View as a list',
	'createMenu': 'Create',
	'newAppItem': 'Dashboard',
	'newDataSet': 'Data set',

	'menuSelectionState_a11y': '"%{item}" selector set to "%{selectedItem}"',

	'unableToShareItem': 'Unable to share item "%{item}".',
	'toastFetchingContent': 'Getting more content...',
	'unableToGetData': 'Unable to get content.',
	'unableToFavorite': 'Unable to change the Favorite status.',
	'hpErrorMissingRequiredOptions': 'Missing required initialization options',
	'unableToOpenBoard': 'Unable to open "%{name}".',
	'unableToDuplicateBoard': 'Unable to duplicate "%{name}".',
	'unableToCreateBoard': 'Unable to create "%{name}".',
	'unableToCreateBoardNameConflict': 'An asset with the same name already exists.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Rows',
	'importWarnings': 'Warnings',
	'lineNumbers': 'Lines',
	'excerptFromSource': 'Excerpt',
	'reason': 'Reason',
	'numberOfRowsDropped': 'rows dropped',
	'oneRowDropped': '1 row was dropped',

	// Type Menu
	'typeMenuLabel': 'Type',
	'dashboardsLabel': 'Dashboards',
	'datasetsLabel': 'Data sets',
	'storiesLabel': 'Stories',
	'allLabel': 'All types',

	// Board Page View App Bar
	'datasets': 'Data sets',
	'settings': 'Properties',
	'add': 'Add',
	'widgets': 'Widgets',
	'dashboardProperties': 'Dashboard properties',
	'searchPanel' : 'Search',
	'pins': 'Collection',
	'pinsOld': 'My pins',
	'pinsDateFilterHeading' : 'Date Pinned',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} pin |||| %{smart_count} pins',
	'pinSearch': 'Search',
	'pinSearchOld': 'Search for pins',
	'pinListView': 'List view',
	'pinIconView': 'Icon view',
	'pinRemove': 'Remove',
	'pinCreate': 'Create',
	'pinDeleteError': 'We can\'t delete one or more assets from the collection. Try again later.',
	'pinDeleteErrorOld': 'We can\'t delete one or more pins. Try again later.',
	'pinRetrieveError': 'We can\'t retrieve one or more pins. Try again later.',
	'NoPinsCollected': 'No pinned visualizations',
	'pinDeletedToast': 'Pin was removed',
	'pinAddedToast': 'Pin was successfully added to My pins',
	'pinningToast': 'Processing pin...',
	'pinDateFilter': 'Date Filter',
	'pinDateFilterAll': 'All',
	'pinDateFilterToday': 'Today',
	'pinDateFilterYesterday': 'Yesterday',
	'pinDateFilterPastWeek': 'Past week',
	'pinDateFilterPastMonth': 'Past month',
	'pinDateFilterEarlier': 'Earlier',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Edit title',
	'toolbarActionSort': 'Sort',
	'toolbarActionSortAscending': 'Sort ascending',
	'toolbarActionSortDescending': 'Sort descending',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Format data',
	'toolbarActionFormatAbbreviation': 'Abbreviate',
	'toolbarActionFormatNone': 'Auto',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Top or bottom',
	'toolbarActionAddShape': 'Add shape',
	'toolbarActionRmvShape': 'Remove shape',
	'toolbarActionToggleShapeDrop': 'Infographic shape',
	'toolbarActionToggleShapeDropTitle': 'Create an infographic',
	'toolbarActionToggleShapeDropText': 'Drag a shape to this field to create an infographic.',
	'toolbarActionAggregationType': 'Summarize',
	'toolbarDeleteActionText': 'Remove column',
	'toolbarActionFilterLocalKeepSelected': 'Keep',
	'toolbarActionFilterLocalExcludeSelected': 'Exclude',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Simple calculation',
	'toolbarActionDrillBack': 'Back',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionNavigate': 'Navigate',
	'toolbarActionCreateFilterGroup': 'Create new connection',
	'toolbarActionDisconnectFilterGroup': 'Break all links',
	'toolbarActionLinkFilterGroup': 'Add to an existing connection',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Add',
	'sidebarMultiselect': 'Toggle multiple selection',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} selected',

	'multiselectWithTotalMsg': '%{count} of %{total}',
	'sidebarGoBack': 'Go back',

	//DataSet pane
	'errorLoadingDataSets': 'We can\'t load this data set',
	'errorLoadingDataSetMetaData': 'We can\'t load this data set',
	'dataSetPaneLastUpdated': 'Last updated: %{date}',
	'dataSetPaneDateUnknown': 'Unknown',
	'sourcePaneLabel': 'Selected sources',
	'addSourceLabel': 'Add a source',
	'find_label': 'Find',
	'navigationPathsLabel': 'Navigation paths',

	//widgetlist
	'errorLoadingWidgetList': 'We can\'t load the objects.',
	'errorLoadingThemeFile': 'We can\'t load the theme definition',
	'errorLoadingLayoutFile': 'We can\'t load the view.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'We can\'t load the available visualization definitions',

	'dwErrorLoadingVisualizationNotFound': 'We can\'t load the object, because it is missing a visualization definition',
	'dwErrorLoadingVisualizationListNotFound': 'We can\'t load the visualization.',
	'dwErrorRunningQuery': 'We can\'t retrieve the data from data set %{datasetName}.',
	'dwErrorGeoData': 'We\'re having trouble displaying the geographic data in a map. Please choose another visualization type. ',
	'dwPromptSignonCancelWarning': 'The data for this visualization is unavailable. Please provide the correct credentials.',
	'dwErrorMissingDataset': 'We can\'t load the visualization, because its associated data set \'%{datasetName}\' isn\'t available.',
	'dwErrorRenderingVisualization': 'We can\'t load this visualization.',
	'dwErrorVisualizationTooSmall': 'The visualization is too small to display the data it contains. Make the visualization larger or limit the data it contains.',
	'aria_label_datatable': 'Data table',
	'aria_key_navi_datatable_desc': 'Use arrow keys to navigate to each cell. Press Control and Home key to move to the first row, Control and End key to move to the last row.',
	'geomapUnrecognizedLocations': 'Unrecognized locations:',
	'geomapAmbiguousLocations': 'Ambiguous regions:',

	// custom widget
	'customWidget': 'Custom widget',
	'customWidgetsTitle': 'Custom widgets',
	'noCustomWidgets': 'No custom widgets',

	// Action names
	'toggleContextBar': 'Toggle the context bar',
	'delete': 'Delete',
	'share': 'Share',
	'unshare': 'Unshare',
	'rename': 'Rename',
	'close': 'Close',
	'duplicate': 'Duplicate',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Retry',

	'changeTemplate': 'Change template',

	// Aggregation Types
	'sum': 'Sum',
	'count': 'Count',
	'countdistinct': 'Count distinct',
	'avg': 'Average',
	'min': 'Minimum',
	'max': 'Maximum',
	'custom': 'Custom',
	'calculated': 'Calculated',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% change',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Visualization criteria...',
	'QuickAddResultsHeader': 'Data visualizations',
	'NoQuickAddResults': 'Nothing matched your intent. Create a new data set?',
	'NoQuickAddResultsRetry': 'We can\'t find any matches. Try again with different terms.',
	'templateWidgetTitle': 'Template',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(blank)',

	'nullValueContent': '(no value)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Text filter - %{columnName}',

	'textFilterSelectTab': 'Select',

	'textFilterConditionTab': 'Set a condition',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'No items are available.',

	'textFilterEquals': 'Equals',
	'textFilterContains': 'Contains',
	'textFilterBeginsWith': 'Begins with',
	'textFilterEndsWith': 'Ends with',
	'textFilterDoesNotEqual': 'Does not equal',
	'textFilterDoesNotContain': 'Does not contain',
	'textFilterDoesNotBeginWith': 'Does not begin with',
	'textFilterDoesNotEndWith': 'Does not end with',
	'textFilterSampleText': 'For example: A',

	'textFilterAndButton': 'And',
	'textFilterOrButton': 'Or',

	'dateFilterMessage': 'Select a range of dates',
	'dateRangeControlRegionLabel': 'Date range filter - %{columnName}',
	'dateFilterRangeOption': 'Range option',
	'dateFilterDateLabel': 'Date',
	'dateFilterBlank': '(blank)',
	'dateFilterBefore': 'Before',
	'dateFilterAfter': 'After',
	'dateFilterBetween': 'Between',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': 'Date',
	'dateIncludeBlankLabel': 'Include blank date',

	'timeTitle': 'Time',
	'timeFilterMessage': 'Select a range of times',
	'dateTimeFilterMessage': 'Select a range of dates and times',

	'topbottomNumberOfResultsLabel': 'Number of results',
	'topbottomPercentLabel': 'Percent',
	'topbottomNumberOfResultsLimit': 'Between %{lower}-%{higher}',
	'topbottomSelectOption': 'Top or bottom option',
	'topbottomOptionLabel': 'Show',
	'searchByLabel': 'By',
	'searchNoMatches': 'No matches found',
	'topbottomRankColumnLabel': 'Add a rank column to table',
	'topbottomNone': 'None',
	'topCount': 'Top count',
	'topPercent': 'Top %',
	'bottomCount': 'Bottom count',
	'bottomPercent': 'Bottom %',
	'topbottomSearchColumn': 'Find a column',
	'searchColumnAriaLabel': 'Find a column. Type the name of the column to search for then use the down arrow to find the column in a list',
	'rankColumnLabel': 'Rank (%{columnLabel})',
	'topbottomClearLabel': 'Clear',

	'rangeFilterControlRegionLabel': 'Range filter - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Slider control, use right and left arrows to move the slider handles',
	'sliderHandleLabel': 'Slider handle',
	'a11ySliderHandleLabel': 'Slider handle %{sliderValue}',
	'sliderInputLabel': 'value',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Some data set items used in this visualization are unavailable.',
	'datasetItemUnavailable': 'This data set item is unavailable',

	//Authoring topBottom
	'topOperator': 'Top',
	'bottomOperator': 'Bottom',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} by %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'This object only',
	'deleteTopBottom': 'Delete top or bottom count',
	'editTopBottom': 'Edit top or bottom count',
	'deleteDrillState': 'Delete current drill state',
	'ariaDeleteDrillStateLabel': 'Press ENTER key to edit top or bottom count.',
	'drillUpStateTitle': 'Drill Up',
	'drillDownStateTitle': 'Drill Down',
	'ariaEditTopBottomLabel': 'Press ENTER key to edit top or bottom count.',
	'ariaDeleteTopBottomLabel': 'Press DELETE key to delete top or bottom count.',

	// Authoring filtering
	'dimFilterIn': 'Includes: %{in}',
	'dimFilterNotIn': 'Excludes: %{out}',
	'measureFilterBetween': 'Between %{lowerBound} and %{upperBound}',
	'measureFilterNotBetween': 'Not between %{lowerBound} and %{upperBound}',
	'gtFilter': 'After %{lowerBound}',
	'ltFilter': 'Before %{upperBound}',
	'notGtFilter': 'Not after %{lowerBound}',
	'notLtFilter': 'Not before %{upperBound}',
	'localFilterTitle': 'This object only',
	'globalFilterTitle': 'All objects',
	'deleteFilter': 'Delete filter',
	'editFilter': 'Edit filter',
	'ariaEditFilterLabel': 'Press ENTER key to edit filter.',
	'ariaDeleteFilterLabel': 'Press DELETE key to delete filter.',

	// Prompts
	'ariaEditPrompt': 'Press ENTER key to change the prompt value',

	'moreDataIndicator': 'Your data was clipped at %{threshold} items. Apply a filter to show less.',

	// data point filtering
	'dataPointFilterTitle': 'Data points',
	'dataPointFilterIncludeSummary': 'Included %{valueCount} data points',
	'dataPointFilterExcludeSummary': 'Excluded %{valueCount} data points',

	// DB2 connection page
	'db2Database': 'DB2 Database (%{jdbcConnection})',
	'db2Title': 'Connect to IBM DB2',

	// Database
	'databaseConnectionMessage': 'Provide your database connection details:',
	'connectionString': 'Database connection string',
	'databaseCredentials': 'Credentials: ',
	'databaseUserName': 'User name',
	'databasePassword': 'Password',
	'databaseConnect': 'Connect',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Enter a search term:',
	'twitterKeyword': 'Keyword',
	'twitterSearch': 'Search',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'We can\'t create the view: %{error}\nFailed operation: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Widget filters',
	'missingColumn': 'Missing: %{columnLabel}',
	'missingFiltering': 'Missing filters on following column IDs:',
	'heatByLabel': 'Heat by',
	'evColumns': 'Columns',
	'evLocalFilters': 'Local filters',
	'evExpand': 'Expand',
	'evFilterTooltip': 'Filter',
	'evAdd': 'Add a column',

	// Navigation View
	'navigationBack': 'Back',

	// Pinning
	'contentPinFail': 'We can\'t collect the content. Try again later.',
	'contentPinFailOld': 'We can\'t pin the content. Try again later.',

	// Layouts
	'dropZoneLabel': 'Drop here to maximize',

	//Share
	'shareDefaultPageTitle': 'Page %{index}',

	'nextPage': 'Next page',
	'previousPage': 'Previous page',

	'assetAssembly': 'view',

	'toolbar_save': 'Save',
	'brgr_saveAs': 'Save as',
	'brgr_refresh': 'Refresh',

	// Save
	'saving': 'Saving...',
	'save_success': 'Your view has been saved.',
	'save_failure': 'We\'re sorry. Your view could not be saved. Please try again later.',
	'dashboard_save_success': 'Your dashboard has been saved.',

	'geminiLeave': 'You are about to leave IBM Watson Analytics.',

	'warning': 'Warning',
	'missingDataSetData': 'The data for this data set is not available. Refresh the data set or contact your administrator for access to the source.',

	// Calculations
	'error_calculation_in_use': 'The selected calculation is in use and cannot be deleted.',

	'resize': 'Resize',
	'rotate': 'Rotate',
	'moveHandle': 'Move widget',
	'expandHandle': 'Expand',
	'panHandle': 'Pan',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navigate to',

	// Slide out titles
	'shapeSlideoutTitle': 'Shapes',
	'textSlideoutTitle': 'Text',
	'mediaSlideoutTitle': 'Media',
	'visualizationSlideoutTitle': 'Visualizations',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Provided JSON is invalid. See error log for more information.',

	// Widget type labels
	'shape_label': 'Shape',
	'image_label': 'Image',
	'data_label': 'Chart',
	'media_label': 'Media',
	'text_label': 'Text',
	'embedMedia_label': 'Media',
	'youtube_label': 'YouTube video',
	'webpage_label': 'Webpage',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Shape',
	'noExtraText_shape_numbered': 'Shape (%{number})',
	'few_shape': 'Group of %{count} shapes',
	'many_shape': 'Group of %{count} shapes',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} image',
	'one_image_numbered': '%{text} image (%{number})',
	'noExtraText_image': 'Image',
	'noExtraText_image_numbered': 'Image (%{number})',
	'few_image': 'Group of %{count} images',
	'many_image': 'Group of %{count} images',
	'noExtraText_text': 'Empty text box',
	'noExtraText_text_numbered': 'Empty text box (%{number})',
	'few_text': 'Group of %{count} text boxes',
	'many_text': 'Group of %{count} text boxes',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube viewer',
	'pacubeviewer_named': '%{name} Cube viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} by %{row_level1} and %{column_level1} crosstab',
	'crosstab_opt_mapping_numbered': '%{values} by %{row_level1} and %{column_level1} (%{number}) crosstab',
	'crosstab_has_mapping': '%{values} by %{row_level1} crosstab',
	'crosstab_has_mapping_numbered': '%{values} by %{row_level1} (%{number}) crosstab',
	'crosstab_no_mapping': 'Empty crosstab',
	'crosstab_no_mapping_numbered': 'Empty crosstab (%{number})',
	'crosstab_named': '%{name} crosstab',
	'crosstab_named_numbered': '%{name} crosstab (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} table',
	'JQGrid_has_mapping_numbered': '%{grid_cols} table (%{number})',
	'JQGrid_no_mapping': 'Empty table',
	'JQGrid_no_mapping_numbered': 'Empty table (%{number})',
	'JQGrid_named': '%{name} table',
	'JQGrid_named_numbered': '%{name} table (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hierarchy',
	'hierarchy_has_mapping_numbered': '%{level1} hierarchy (%{number})',
	'hierarchy_no_mapping': 'Empty hierarchy',
	'hierarchy_no_mapping_numbered': 'Empty hierarchy (%{number})',
	'hierarchy_named': '%{name} hierarchy',
	'hierarchy_named_numbered': '%{name} hierarchy (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} map',
	'map_has_mapping_numbered': '%{categories} map (%{number})',
	'map_no_mapping': 'Empty map',
	'map_no_mapping_numbered': 'Empty map (%{number})',
	'map_named': '%{name} map',
	'map_named_numbered': '%{name} map (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} summary value',
	'summary_has_mapping_numbered': '%{actual} summary value (%{number})',
	'summary_no_mapping': 'Empty summary value',
	'summary_no_mapping_numbered': 'Empty summary value (%{number})',
	'summary_named': '%{name} summary value',
	'summary_named_numbered': '%{name} summary value (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} by %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} by %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Empty KPI',
	'kpi_no_mapping_numbered': 'Empty KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infographic',
	'infographicSummary_has_mapping_numbered': '%{actual} infographic (%{number})',
	'infographicSummary_no_mapping': 'Empty infographic',
	'infographicSummary_no_mapping_numbered': 'Empty infographic (%{number})',
	'infographicSummary_named': '%{name} infographic',
	'infographicSummary_named_numbered': '%{name} infographic (%{number})',
	'noExtraText_youtube': 'YouTube video',
	'noExtraText_youtube_numbered': 'YouTube video (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube video',
	'one_youtube_numbered': '%{text} YouTube video (%{number})',
	'few_youtube': 'Group of %{count} YouTube videos',
	'many_youtube': 'Group of %{count} YouTube videos',
	'noExtraText_embedMedia': 'Media link',
	'noExtraText_embedMedia_numbered': 'Media link (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} media link',
	'one_embedMedia_numbered': '%{text} media link (%{number})',
	'few_embedMedia': 'Group of %{count} media links',
	'many_embedMedia': 'Group of %{count} media links',
	'noExtraText_media': 'Media',
	'noExtraText_media_numbered': 'Media (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} media',
	'one_media_numbered': '%{text} media (%{number})',
	'few_media': 'Group of %{count} media',
	'many_media': 'Group of %{count} media',
	'noExtraText_webpage': 'Web page',
	'noExtraText_webpage_numbered': 'Web page (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} web page',
	'one_webpage_numbered': '%{text} web page (%{number})',
	'few_webpage': 'Group of %{count} web pages',
	'many_webpage': 'Group of %{count} web pages',
	'one_unknown': 'An object',
	'one_unknown_numbered': 'An object (%{number})',
	'few_unknown': 'Group of %{count} objects',
	'many_unknown': 'Group of %{count} objects',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Next',
	'previous': 'Previous',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Current navigation group is %{navigation_group_name}',

	//Page Context
	'filterBlank': '(blank)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Filter values can\'t be loaded',
	'editTimelineHighlight': 'Edit highlight',

	'filterDockChevronLeft': 'Scroll through the data',
	'filterDockChevronRight': 'Scroll through the data',
	'expand': 'Expand',
	'collapse': 'Collapse',

	//Reset Dashboard
	'dashboardResetTitle': 'Reset dashboard',
	'dashboardResetMessage': 'Are you sure you want to reset all changes applied to this dashboard?',
	'dashboardResetToast': 'Your dashboard has been reset.',

	//Generate PDF
	'buildingPDF': 'Building PDF...',
	'exportPDF': 'Export to PDF',
	'pageSize': 'Page size',
	'orientation': 'Orientation',
	'filtersPresentPDF': 'Filter(s) applied to the visualization(s) on the previous page:',
	'errorPDF': 'Unable to generate PDF. Please refresh and try again.',
	'printPDFInfo': 'View documentation',
	'pdfWidget': 'Widget',
	'includeFilters': 'Show filter details',
	'portrait': 'Portrait',
	'landscape': 'Landscape',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Your dashboard has been upgraded. Save now to maintain optimum performance.',

	'ariaFullScreenMessage': 'Press Escape to exit full screen',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} packed hierarchy bubble chart',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} packed hierarchy bubble chart (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Empty packed hierarchy bubble chart',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Empty packed hierarchy bubble chart (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} packed hierarchy bubble chart',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} packed hierarchy bubble chart (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} by %{values} marimekko chart',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} by %{values} marimekko chart (%{number})',
	'LIVE_marimekko_no_mapping': 'Empty marimekko chart',
	'LIVE_marimekko_no_mapping_numbered': 'Empty marimekko chart (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko chart',
	'LIVE_marimekko_numbered': '%{name} marimekko chart (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} sunburst chart',
	'LIVE_sunburst_has_mapping_numbered': '%{values} sunburst chart (%{number})',
	'LIVE_sunburst_no_mapping': 'Empty sunburst chart',
	'LIVE_sunburst_no_mapping_numbered': 'Empty sunburst chart (%{number})',
	'LIVE_sunburst_named': '%{name} sunburst chart',
	'LIVE_sunburst_named_numbered': '%{name} sunburst chart (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} driver analysis chart',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} driver analysis chart (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Empty driver analysis chart',
	'LIVE_decision_analysis_no_mapping_numbered': 'Empty driver analysis chart (%{number})',
	'LIVE_decision_analysis_named': '%{name} driver analysis chart',
	'LIVE_decision_analysis_named_numbered': '%{name} driver analysis chart (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} by %{columnValue} and %{lineValue} line and column chart',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} by %{columnValue} and %{lineValue} line and column chart (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} and %{lineValue} line and column chart',
	'LIVE_line_column_has_mapping_numbered': '%{categories} by %{columnValue} and %{lineValue} line and column chart (%{number})',
	'LIVE_line_column_no_mapping': 'Empty line and column chart',
	'LIVE_line_column_no_mapping_numbered': 'Empty line and column chart (%{number})',
	'LIVE_line_column_named': '%{name} line and column chart',
	'LIVE_line_column_named_numbered' : '%{name} line and column chart (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} by %{y} and %{size} bubble chart',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} by %{y} and %{size} bubble chart (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Empty bubble chart',
	'LIVE_bubble_chart_no_mapping_numbered': 'Empty bubble chart (%{number})',
	'LIVE_bubble_chart_named': '%{name} bubble chart',
	'LIVE_bubble_chart_named_numbered': '%{name} bubble chart (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} bullet chart',
	'LIVE_bullet_has_mapping_numbered': '%{actual} bullet chart (%{number})',
	'LIVE_bullet_no_mapping': 'Empty bullet chart',
	'LIVE_bullet_no_mapping_numbered': 'Empty bullet chart (%{number})',
	'LIVE_bullet_named': '%{name} bullet chart',
	'LIVE_bullet_named_numbered': '%{name} bullet chart (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Data on this dashboard is provided by',
	'showFooterToggleButtonText': 'Show footer',
	'showFooterSectionText': 'Footer'
});
